export const YOMA_LOGO_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 200">
  <style>
    .yoma { font-family: "Playfair Display", serif; font-size: 80px; letter-spacing: 20px; fill: #b8a899; }
    .design { font-family: "Montserrat", sans-serif; font-size: 28px; letter-spacing: 12px; fill: #b8a899; }
  </style>

  <text x="50%" y="90" text-anchor="middle" class="yoma">YOMA</text>
  <text x="50%" y="150" text-anchor="middle" class="design">DESIGN</text>
</svg>
`;

